
import React, { useEffect, useState } from 'react';
import { HiArrowLeft } from "react-icons/hi2";
import { useNavigate, useSearchParams } from "react-router-dom";

import axios from "axios";
import { Button, Navbar } from 'flowbite-react';
import moment from "moment";
import { ONBOARDING_API_ENDPOINT } from "../config/url.config";
import { navigateToSessionExpired } from "../utils/sessionExpired";
import { documentsWasUpdatedByUser } from "../utils/updatedByUser";
import { getAuthHeader } from "../utils/superFetch";

const PersonalDetails = (props) => {
  const [emergencyContactDetails, setEmergencyContactDetails] = useState({})
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  let [submitButtonState, setButtonState] = useState(true)
  const selectedProfileType = JSON.parse(sessionStorage.getItem("selectedProfileType"));
  let [validation, setValidation] = useState({ show: false , message: "", class:""});
  let [userUpdatedData, setUserUpdatedData] = useState(false)

  useEffect(()=>{
    for(let requiredItems of props.memberRequirement.requiredDocuments[props.itemIndex].requiredItems) {
      if (requiredItems.value !== "" && requiredItems.itemName === 'name') {
        setEmergencyContactDetails(emergencyContactDetails => ({...emergencyContactDetails, name: requiredItems.value}))
      }
      if (requiredItems.value !== "" && requiredItems.itemName === 'relationship') {
        setEmergencyContactDetails(emergencyContactDetails => ({...emergencyContactDetails, relationship: requiredItems.value}))
      }
      if (requiredItems.value !== "" && requiredItems.itemName === 'contactNumber') {
        setEmergencyContactDetails(emergencyContactDetails => ({...emergencyContactDetails, contactNumber: requiredItems.value}))
      }
    }
    setUserUpdatedData(false)
    updateButtonStatus()
  },[])

  const handleEmergencyDetailsUpdate = (field, value) => {
    setEmergencyContactDetails(emergencyContactDetails => ({...emergencyContactDetails , [`${field}`]:value}))
  }

  const updateButtonStatus = () => {
    for (const key in emergencyContactDetails) {
      if (emergencyContactDetails[`${key}`] === "") {
        setButtonState(true)
        return
      }
    }
    setButtonState(false)
  }

  const validateOnChange = () => {
    if (validation.show && emergencyContactDetails.name === '') {
      setValidation({ show: true , message: "Missing name of emergency contact", class:"error-msg"})
      return 
    }
    else if (validation.show && emergencyContactDetails.relationship === '') {
      setValidation({ show: true , message: "Missing relationship details of emergency contact", class:"error-msg"})
      return 
    }
    else if (validation.show && (emergencyContactDetails.contactNumber === '' || emergencyContactDetails.contactNumber.length > 8)) {
      setValidation({ show: true , message: "Provide valid contact number of emergency contact", class:"error-msg"})
      return 
    } else {
      setValidation({ show: false , message: "", class:""})
      return
    }
  }

  const handleEmergencyContactUpload = async () => {
    if (userUpdatedData === false) {
      props.setOpenUploadDocument({openDocument : false , documentType : ""})
      return
    }
    
    if (emergencyContactDetails.name === '') {
      setValidation({ show: true , message: "Missing name of emergency contact", class:"error-msg"})
      return 
    }
    if (emergencyContactDetails.relationship === '') {
      setValidation({ show: true , message: "Missing relationship details of emergency contact", class:"error-msg"})
      return 
    }
    if (emergencyContactDetails.contactNumber === '' || emergencyContactDetails.contactNumber.length > 8) {
      setValidation({ show: true , message: "Provide valid contact number of emergency contact", class:"error-msg"})
      return 
    }
    let dataBody = {
      item : "emergencyContact" ,
      requiredItems: [
        {
          itemName: 'name' ,
          value: emergencyContactDetails.name
        },
        {
          itemName: 'relationship' ,
          value: emergencyContactDetails.relationship
        },
        {
          itemName: 'contactNumber' ,
          value: emergencyContactDetails.contactNumber
        },
      ]
    }
    
    const config = {
      headers: { "content-type": "application/json", "upload-document": false , ...getAuthHeader() },
    };
    
     try {
      const endpoint = `${ONBOARDING_API_ENDPOINT}/api/onboarding/updateConfiguration?profileType=${selectedProfileType.profileId}`;
      const res = await axios.post(endpoint, dataBody, config);
      if (res.status) {
        let tmpMemberData = {...props.memberRequirement}
        for (let i =0 ; i < tmpMemberData.requiredDocuments[props.itemIndex].requiredItems.length ;i++) {
          if (tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i].itemName in emergencyContactDetails) {
            if(tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i].status === 2 || 
              tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i].value !== '') {
              documentsWasUpdatedByUser(`${tmpMemberData.requiredDocuments[props.itemIndex].item}`)
            }

            tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i].value = emergencyContactDetails[`${tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i].itemName}`]
            tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i].uploadedTime = moment.unix()
            
          } 
        }
          props.setMemberRequirement(tmpMemberData)
          props.setOpenUploadDocument({openDocument : false , documentType : ""})
      
      }
      return
    } catch (err) {
     
     navigateToSessionExpired(navigate, {
      reason: "emergency_contact_submit_failed",
      source: "handleEmergencyContactUpload",
      component: "EmergencyContact",
      status: err?.response?.status,
      message: err?.message,
     })
    }
  }


  return (
    <>
      <Navbar
        fluid={true}
        rounded={true}
        className='shadow mb-3' style={{position:'fixed', width:'100%', top:'0'}}>
          
            <Navbar.Brand onClick={()=>{props.setOpenUploadDocument({openDocument : false , documentType : ""})}}>
             
                  <HiArrowLeft className='h-10 w-5 ml-2' />
             
            </Navbar.Brand>
          
        
      </Navbar>
    <div className='p-6 max-w-md m-auto' style={{paddingTop:'80px'}}>
        <h5 className="text-2xl mb-2 font-bold tracking-tight text-gray-900 dark:text-white">
          Emergency Contact
        </h5>
        <p className='mb-8 text-gray-600'>Fill in Emergency Contact, Ryde is committed to the privacy of user data. Your Emergency Contacts will only receive an SMS in case of an emergency.</p>

        { validation.show &&
                  
                  <div className={validation.class}>
                      <span >{validation.message}</span>
                  </div>
              
              }
      <div className="hidden sm:block" aria-hidden="true">
        <div className="py-5">
          <div className="border-t border-gray-200" />
        </div>
      </div>


            <form action="#" method="POST">
              <div className="overflow-hidden sm:rounded-md">
                <div className="bg-white py-5 ">
                  <div className="grid grid-cols-6 gap-6">
                  <div className="col-span-6">
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                        Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        id="name"
                        autoComplete="name"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        onChange={(e)=>{setUserUpdatedData(() => true); handleEmergencyDetailsUpdate('name',e.target.value); validateOnChange();}}
                        value={emergencyContactDetails.name}
                      />
                    </div>

                    <div className="col-span-6">
                      <label htmlFor="Relationship" className="block text-sm font-medium text-gray-700">
                        Relationship
                      </label>
                      <select
                        id="Relationship"
                        name="Relationship"
                        autoComplete="Relationship"
                        className="mt-1 block w-full rounded-md border border-gray-300 bg-white py-2 px-3 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                        onChange={(e)=>{setUserUpdatedData(() => true);handleEmergencyDetailsUpdate('relationship',e.target.value); validateOnChange();}}
                        defaultValue={emergencyContactDetails.relationship}
                        value={emergencyContactDetails.relationship}
                      >
                         <option value=""></option>
                        <option value="Brother">Brother</option>
                        <option value="Sister">Sister</option>
                        <option value="Father">Father</option>
                        <option value="Mother">Mother</option>
                        <option value="Husband">Husband</option>
                        <option value="Wife">Wife</option>
                      </select>
                    </div>

                    <div className="col-span-6">
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                        Contact Number
                      </label>
                      <input
                        type="number"
                        name="contact-number"
                        maxlength="8"
                        id=""
                        autoComplete="name"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        onChange={(e)=>{setUserUpdatedData(() => true);handleEmergencyDetailsUpdate('contactNumber',e.target.value); validateOnChange();}}
                        value={emergencyContactDetails.contactNumber}
                      />
                    </div>
                  </div>
                </div>
                <Button className='bg-primary w-full mt-5' pill={true} disabled={submitButtonState}
                onClick={()=>{handleEmergencyContactUpload()}}>
                    Save
                  </Button>
                 
  
              </div>
            </form>
          

      </div>
    
    </>
  )
}

export default PersonalDetails;